{
  "language": {
    "select": "Change language",
    "saveError": "We couldn't save your language to your profile."
  },
  "dateRangePicker": {
    "placeholder": "Select a date range",
    "dateFormat": "LLL dd"
  },
  "toast": {
    "error": "Error",
    "success": "Success"
  },
  "whatsApp": {
    "ariaLabel": "Chat with us on WhatsApp",
    "tooltip": "Chat with us"
  },
  "loader": {
    "loading": "Loading...",
    "preparing": "Getting an amazing experience ready...",
    "loadingVideo": "Loading video player...",
    "calculatingStats": "Crunching your stats",
    "analyzingProgress": "Analyzing your progress...",
    "pleaseWait": "Just a moment...",
    "navigating": "Navigating..."
  },
  "notifications": {
    "reasons": {
      "lessonCompleted": "Completed a lesson",
      "moduleCompleted": "Completed a module",
      "courseCompleted": "Finished a course",
      "commentPosted": "Posted a comment",
      "dailyLogin": "Daily login",
      "streakBonus": "Streak bonus",
      "quizCompleted": "Completed a quiz",
      "certificateEarned": "Earned a certificate",
      "exerciseCompleted": "Completed an exercise",
      "projectSubmitted": "Submitted a project",
      "helpColleague": "Helped a classmate",
      "firstLesson": "First lesson completed",
      "communityPostCreated": "Created a community post",
      "communityCommentCreated": "Commented in the community",
      "communityPostLiked": "Liked a community post",
      "communityCommentLiked": "Liked a comment",
      "communityMentioned": "Mentioned in the community",
      "courseStarted": "Started a course",
      "courseProgress": "Progressed in the course",
      "lessonFavorited": "Favorited a lesson",
      "postLiked": "Liked a post",
      "postReplied": "Replied to a post",
      "postShared": "Shared a post",
      "dailyChecklistBonus": "Daily Trifecta bonus"
    },
    "timeAgo": {
      "now": "now"
    },
    "grouped": {
      "title": "+{{points}} XP today",
      "message": "{{count}} actions earned points today"
    },
    "clickToView": "Click to view",
    "title": "Notifications",
    "newCount_one": "{{count}} new",
    "newCount_zero": "{{count}} new",
    "newCount_other": "{{count}} new",
    "markAllRead": "Mark as read",
    "filters": {
      "all": "All",
      "unread": "Unread"
    },
    "loading": "Loading...",
    "empty": {
      "unreadTitle": "All caught up!",
      "allTitle": "No notifications",
      "unreadDescription": "You have no pending notifications",
      "allDescription": "Your notifications will show up here"
    }
  },
  "videoField": {
    "variants": {
      "mirroredRoot": {
        "name": "Mirrored root",
        "description": "Canopy and roots meeting at the horizon line"
      },
      "particleCanopy": {
        "name": "Particle canopy",
        "description": "A column of light blooming into particles"
      },
      "waterMonolith": {
        "name": "Monolith on water",
        "description": "A sculpture of the symbol reflected in still water"
      }
    }
  },
  "gamifiedAvatar": {
    "title": "{{level}} - {{points}} XP"
  },
  "imageUpload": {
    "invalidType": "Please select an image",
    "tooLarge": "The image must be 5MB or smaller",
    "uploadError": "Failed to upload the image",
    "previewAlt": "Preview",
    "replace": "Replace",
    "remove": "Remove",
    "uploading": "Uploading...",
    "dropzone": "Click or drag an image here",
    "hint": "JPG, PNG, GIF or WebP up to 5MB"
  },
  "colorPicker": {
    "color": "Color",
    "hue": "Hue",
    "hex": "Hex",
    "preview": "Preview",
    "currentColor": "Current color",
    "newColor": "New color",
    "presets": "Preset colors",
    "cancel": "Cancel",
    "apply": "Apply"
  },
  "pwaDashboard": {
    "initializing": "Initializing PWA...",
    "title": "Progressive Web App",
    "subtitle": "Configure and monitor the platform's PWA features",
    "online": "Online",
    "offline": "Offline",
    "installed": "Installed",
    "dismiss": "Dismiss",
    "install": {
      "title": "Installation",
      "description": "Install the app for quick access and offline features",
      "success": "App installed successfully!",
      "available": "The app can be installed on your device.",
      "button": "Install app",
      "notNow": "Not now",
      "unavailable": "Installation isn't available right now.",
      "unavailableHint": "This can happen if the app is already installed or your browser doesn't support PWA installation.",
      "stats": {
        "promptsShown": "Prompts shown",
        "installs": "Installs",
        "dismissed": "Dismissed"
      }
    },
    "updates": {
      "title": "Updates",
      "description": "Keep the app up to date",
      "newVersion": "New version available!",
      "upToDate": "App is up to date",
      "lastCheck": "Last checked: {{date}}",
      "neverChecked": "Never checked",
      "updateNow": "Update now",
      "checkForUpdates": "Check for updates",
      "info": "Update details:",
      "status": "Status: {{status}}",
      "waiting": "Waiting",
      "available": "Available",
      "size": "Size: {{size}}",
      "changes": "Changes:"
    },
    "features": {
      "title": "PWA features",
      "description": "Advanced progressive web app features",
      "active": "Active",
      "inactive": "Inactive",
      "offline": {
        "name": "Offline mode",
        "description": "Access content even without internet"
      },
      "push": {
        "name": "Push notifications",
        "description": "Get important notifications"
      },
      "backgroundSync": {
        "name": "Background sync",
        "description": "Sync data automatically"
      }
    },
    "metrics": {
      "title": "Usage metrics",
      "totalInstalls": "Total installs",
      "dailyActiveUsers": "Active users (today)",
      "retentionRate": "Retention rate",
      "offlineUsage": "Offline usage",
      "updateSuccessRate": "Update success rate"
    },
    "storage": {
      "title": "Storage",
      "appCache": "App cache",
      "platforms": "Platforms",
      "installs_one": "{{count}} install",
      "installs_zero": "{{count}} installs",
      "installs_other": "{{count}} installs",
      "refresh": "Refresh info"
    },
    "security": {
      "title": "Security & privacy",
      "https": "App served over HTTPS",
      "secure": "Secure",
      "serviceWorker": "Service Worker active",
      "notice": "All data is stored locally and encrypted. The app works offline while respecting your privacy."
    }
  },
  "pwa": {
    "manifest": {
      "name": "Xtreed - Learning Platform",
      "description": "A complete learning platform for software development",
      "shortcuts": {
        "courses": {
          "name": "My courses",
          "shortName": "Courses",
          "description": "Go to my courses"
        },
        "achievements": {
          "name": "Achievements",
          "shortName": "Achievements",
          "description": "See my achievements"
        }
      }
    },
    "errors": {
      "initializationFailed": "PWA initialization failed",
      "unknown": "Unknown error",
      "installPromptUnavailable": "Install prompt not available",
      "installFailed": "Install failed",
      "updateCheckFailed": "Update check failed",
      "skipWaitingFailed": "Couldn't apply the update",
      "serviceWorkerNotRegistered": "Service Worker not registered",
      "workboxNotInitialized": "Workbox not initialized",
      "notificationsNotSupported": "Notifications not supported",
      "notificationPermissionDenied": "Notification permission denied"
    }
  },
  "coursePlaceholder": "Course",
  "tenant": {
    "defaultName": "Members Area"
  },
  "gamificationWidget": {
    "nextLevel": "Next level:",
    "xpToNext": "<strong>{{xp}} XP</strong> to go",
    "maxLevel": "You reached the top level. Keep earning XP to climb the leaderboard.",
    "earnXpHint": "Earn XP by completing lessons, commenting and keeping your study streak.",
    "position": "Position",
    "streak": "Streak",
    "streakDays_one": "{{count}} day",
    "streakDays_zero": "{{count}} days",
    "streakDays_other": "{{count}} days",
    "viewRanking": "View leaderboard"
  }
}
